import { render, staticRenderFns } from "./ProcessNewInvestigator.vue?vue&type=template&id=3821bc6c&scoped=true"
import script from "./ProcessNewInvestigator.vue?vue&type=script&lang=js"
export * from "./ProcessNewInvestigator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3821bc6c",
  null
  
)

export default component.exports